import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper/modules";

import acne from "../../Images/acne.webp";
import haircare from "../../Images/hair care.webp";
import dullSkin from "../../Images/Dull Skin.webp";
import tan from "../../Images/Tanning (1).webp";
import oily from "../../Images/Oily skin.webp";
import dry from "../../Images/Dry skin.webp";
import aging from "../../Images/aging.webp";
import spot from "../../Images/spot.jpg";

import "./ShopByCategory.css";

// Cica Care
// Face Wash
// Sunscreen Cream
// Hand Wash
// Shower Gel
// Soothing Gel
// Hair Oil
// Hair Shampoo
// Hair Conditioner
// Moisturizer
// Mist Toner
// Lotion
// Air Freshener

const concerns = [
  {
    slug: "cica%20care",
    label: "Cica Care",
    img: "https://i.ibb.co.com/TDCHDfvS/ebay-category-img-10.avif",
    alt: "Acne skincare products",
  },
  {
    slug: "face%20wash",
    label: "Face Wash",
    img: "https://i.ibb.co.com/Q38Fnncz/ebay-category-img-2.avif",
    alt: "Hair care solutions",
  },
  {
    slug: "hand%20wash",
    label: "Hand Wash",
    img: "https://i.ibb.co.com/nsWNtZWD/ebay-category-img-8.avif",
    alt: "Brightening for dull skin",
  },
  {
    slug: "shower%20gel",
    label: "Shower Gel",
    img: "https://i.ibb.co.com/n8nz35Ck/ebay-category-img-7.avif",
    alt: "Anti-tan skincare",
  },
  {
    slug: "air%20freshener",
    label: "Air Freshener",
    img: "https://i.ibb.co.com/xqRFHbBm/ebay-category-img-3.avif",
    alt: "Oil control skincare",
  },
  {
    slug: "lotion",
    label: "Lotion",
    img: "https://i.ibb.co.com/KcT6WkdV/ebay-category-img-6.avif",
    alt: "Hydrating for dry skin",
  },
  {
    slug: "shampoo",
    label: "Hair Shampoo",
    img: "https://i.ibb.co.com/8L8XD1MG/ebay-category-img-1.avif",
    alt: "Anti-aging skincare",
  },
  {
    slug: "oil",
    label: "Hair Oil",
    img: "https://i.ibb.co.com/mCDShnQ1/ebay-category-img-4.avif",
    alt: "Spot treatment skincare",
  },
];

const structuredData = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Shop by Concern",
  description:
    "Browse skincare and haircare products by concern including acne, dull skin, tanning, oily skin, dry skin, aging, and spots.",
  hasPart: concerns.map((c) => ({
    "@type": "CollectionPage",
    name: c.label,
    url: `https://earthbeautyandyou.com/product-category/${c.slug}`,
  })),
};

const ShopByCategory = () => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <section
      className="shopByConcern"
      aria-label="Shop by Skin & Hair Concerns"
    >
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>

      {/* Section Header */}
      <div className="text-center mb-8 px-4">
        <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#729B7F] mb-3">
          Targeted Solutions
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Shop by Category
        </h2>
        <div className="w-14 h-0.5 bg-gradient-to-r from-[#729B7F] to-[#abcacb] mx-auto" />
      </div>

      <Swiper
        modules={[Autoplay]}
        slidesPerView={2.5}
        spaceBetween={16}
        autoplay={{
          delay: 1500, 
          disableOnInteraction: false, 
          pauseOnMouseEnter: true,
        }}
        loop={false}
        breakpoints={{
          480: { slidesPerView: 3, spaceBetween: 10 },
          768: { slidesPerView: 4, spaceBetween: 12 },
          1024: { slidesPerView: 5, spaceBetween: 28 },
          1400: { slidesPerView: 5, spaceBetween: 28 },
        }}
        grabCursor={!isDragging}
        onMouseDown={() => setIsDragging(true)}
        onMouseUp={() => setIsDragging(false)}
        className="shopConcern"
      >
        {concerns.map((concern) => (
          <SwiperSlide key={concern.slug}>
            <Link
              to={`/product-category/${concern.slug}`}
              title={`Shop ${concern.label} products`}
              className="concern-card flex flex-col items-center group"
            >
              <div className="relative rrrounded-full overflow-hidden ring-2 ring-transparent group-hover:ring-[#729B7F] transition-all duration-300 shadow-md">
                <img
                  className=" w-[155px] h-[155px] md:w-[250px] md:h-[250px]  rrrounded-full object-cover"
                  width={255}
                  height={255}
                  src={concern.img}
                  alt={concern.alt}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-[#729B7F]/0 group-hover:bg-[#729B7F]/10 rounded-full transition-all duration-300" />
              </div>
              <p className="text-center mt-4 text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#729B7F] transition-colors duration-200">
                {concern.label}
              </p>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ShopByCategory;
